import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { BarChart3, Eye, MousePointerClick, TrendingUp } from 'lucide-react';

export default function AdAnalyticsTab({ stats }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5" />
          Ad Performance
        </CardTitle>
        <CardDescription>Track impressions, clicks, and CTR across placements</CardDescription>
      </CardHeader>
      <CardContent>
        {stats.length > 0 ? (
          <div className="grid gap-4 md:grid-cols-2">
            {stats.map((stat) => (
              <Card key={stat.placement} className="bg-muted/30">
                <CardContent className="pt-4">
                  <h4 className="font-medium capitalize mb-3">
                    {stat.placement.replace(/_/g, ' ')}
                  </h4>
                  <div className="grid grid-cols-3 gap-4 text-center">
                    <div>
                      <Eye className="w-4 h-4 mx-auto mb-1 text-muted-foreground" />
                      <p className="text-2xl font-bold">
                        {stat.impressions.toLocaleString()}
                      </p>
                      <p className="text-xs text-muted-foreground">Impressions</p>
                    </div>
                    <div>
                      <MousePointerClick className="w-4 h-4 mx-auto mb-1 text-muted-foreground" />
                      <p className="text-2xl font-bold">{stat.clicks.toLocaleString()}</p>
                      <p className="text-xs text-muted-foreground">Clicks</p>
                    </div>
                    <div>
                      <TrendingUp className="w-4 h-4 mx-auto mb-1 text-muted-foreground" />
                      <p className="text-2xl font-bold">{stat.ctr}%</p>
                      <p className="text-xs text-muted-foreground">CTR</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-muted-foreground">
            <BarChart3 className="w-12 h-12 mx-auto mb-4 opacity-50" />
            <p>No ad performance data yet</p>
            <p className="text-sm">Stats will appear as ads are served</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
